import React from "react";
import img from "../../../assets/images/imgdetails.png";
import { ImagePreview } from "../../diseases/details/gallery";

const AboutDetails = ({ image }) => {
  return (
    <div className="container">
      <div className="about-details-blog pad--large">
        <div className="flex-center">
          <button class="btn btn--border">News</button>
          <p className="pad--small">November 25, 2022</p>
        </div>
        <>
          <h1 className="address-blog">Address Blog</h1>
          <p>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.Amet minim mollit non deserunt
            ullamco est sit aliqua dolor do amet sint. Velit officia consequat
            duis enim velit mollit. Exercitation veniam consequat sunt nostrud
            amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do
            amet sint. Velit officia consequat duis enim velit mollit.
            Exercitation veniam consequat sunt nostrud amet.
          </p>
        </>
        <>
          <h1>About the Diseases</h1>
          <p>
            Uniquely matrix economically sound value through cooperative
            technology. Competently parallel task fully researched data and
            enterprise process improvements. Collaboratively expedite quality
            manufactured products via client-focused results quickly communicate
            enabled technology and turnkey leadership skills. Uniquely enable
            accurate supply chains rather than friction technology.
          </p>
        </>
        <div className="flex-between about-details-sec">
          <ImagePreview image={image} />
          <div className="right-sec">
            <h2>Symptoms of the disease</h2>
            <p>
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do
              amet sint. Velit officia consequat duis enim velit mollit.
              Exercitation veniam consequat sunt nostrud amet. Amet minim mollit
              non deserunt ullamco est sit aliqua dolor do amet sint. Velit
              officia consequat duis enim velit mollit. Exercitation veniam
              consequat sunt nostrud amet.Amet minim mollit non deserunt ullamco
              est sit aliqua dolor
            </p>
          </div>
        </div>
        <>
          <h1>Simple blog summary</h1>
          <p>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet. Amet minim mollit non deserunt
            ullamco est sit aliqua dolor do amet sint. Velit officia consequat
            duis enim velit mollit. Exercitation veniam consequat sunt nostrud
            amet.Amet minim mollit non deserunt ullamco est sit aliqua dolor
          </p>
        </>
      </div>
    </div>
  );
};

export default AboutDetails;
